






































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetTerms } from "@/request/projects";
import Jiatingzhuzhi from "./custom-contents/jiatingzhuzhi.vue";
import Zhusu from "./custom-contents/zhusu.vue";
import Xianbingshi from "./custom-contents/xianbingshi.vue";
import Zhongyaoyinpian from "./custom-contents/zhongyaoyinpian.vue";
import Qitayongyao from "./custom-contents/qitayongyao.vue";
import Wenjian from "./custom-contents/wenjian.vue";
import Shipin from "./custom-contents/shipin.vue";
import Jifentiao from "./custom-contents/jifentiao.vue";
import Yatongdian from "./custom-contents/yatongdian.vue";
@Component({
  components: {
    Jiatingzhuzhi,
    Zhusu,
    Xianbingshi,
    Zhongyaoyinpian,
    Qitayongyao,
    Wenjian,
    Shipin,
    Jifentiao,
    Yatongdian,
  },
})
export default class TemplateTransfer extends Vue {
  @Prop()
  private index: any;
  @Prop()
  private content: any;
  @Prop()
  private bitianMsg: any;
  private scoreRadioSelected: any = "";
  private resultOptions: any[] = [];
  /**
   * @description 获取store中的可编辑状态
   */
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }

  /**
   * @description content双向绑定
   */
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  @Watch("content.type", { immediate: true })
  private contentTypeChange(type) {
    if (this.content["type"] === "主标题" && this.content["title"]) {
      this.$nextTick().then(() => {
        this.content["value"] = this.content["title"];
        this.content["title"] = "";
      });
    }
    if (this.content["type"] === "段落标题" && this.content["title"]) {
      this.$nextTick().then(() => {
        this.content["value"] = this.content["title"];
        this.content["title"] = "";
      });
    }
    if (this.content["type"] === "计分单选") {
      this.$nextTick().then(() => {
        if (this.content.value) {
          const name = this.content.value.name;
          this.content.options.map((item: any, index: any) => {
            if (item.name === name) {
              this.scoreRadioSelected = index;
            }
          });
        }
      });
    }
    if (this.content["type"] === "多选") {
      this.$nextTick().then(() => {
        if (!Array.isArray(this.content.value)) {
          this.content.value = [];
        }
      });
    }
    if (this.content["type"] === "压痛点") {
      if (!this.content.value["L左侧"]) {
        this.$set(this.content.value, "L左侧", {});
      }
      if (!this.content.value["R右侧"]) {
        this.$set(this.content.value, "R右侧", {});
      }
    }
    if (this.content["type"] === "sf36计分单选") {
      this.$nextTick().then(() => {
        if (this.content.value) {
          const name = this.content.value.name;
          this.content.options.map((item: any, index: any) => {
            if (item.name === name) {
              this.scoreRadioSelected = index;
            }
          });
        }
      });
    }
    if (this.content["type"] === "搜索多选") {
      this.$nextTick().then(() => {
        this.resultOptions = this.content.value;
      });
    }
    if (this.content["type"] === "文件") {
      // this.createOss().then(() => {
      //   this.ossReady = true;
      // });
    }
    if (this.content["type"] === "计分条") {
      if (this.content.value === "") {
        this.content.value = 0;
      }
    }
  }
  /**
   * @description 单选按钮点击
   */
  private radioClick(ev) {
    this.content.value === ev
      ? (this.content.value = "")
      : (this.content.value = ev);
  }
  /**
   * @description 计分单选按钮点击
   */
  private radioScoreClick(option) {
    this.content.value = option;
    const name = this.content.value.name;
    this.content.options.map((item: any, index: any) => {
      if (item.name === name) {
        this.scoreRadioSelected = index;
      }
    });
    // this.content.value["name"] === option["name"]
    //   ? (this.content.value = {})
    //   : (this.content.value = option);
  }
  /**
   * @description 计分单选变化处理
   */
  private scoreRadioChange(value) {
    this.content.value = this.content.options[value];
  }
  /**
   * @description 清除单选补充文字选项
   */
  private clearSelect() {
    this.content.options.forEach((ele) => {
      ele.value = false;
      if (ele.content) {
        ele.content = "";
      }
    });
  }
  /**
   * @description 搜索
   */
  private fetchOptions(ev) {
    let searchType: string = this.content["search"];
    if (searchType === "伴随症状") {
      searchType = "中医症状";
    }
    const params: any = {
      params: {
        type: searchType,
        search: ev,
      },
    };
    GetTerms(this, params).then((data: any) => {
      this.resultOptions = data.concat(this.content.value);
    });
  }
  /**
   * @description 计算是否应该是灰色背景
   */
  private calGrayBack(index) {
    // 3,4,7,8,11,12,15,16,19,20
    index++;
    const t = (index + 1) % 4;
    if (t === 0) {
      return true;
    }
    if (index % 4 === 0) {
      return true;
    }
    return false;
  }
  /**
   * @description 多多嵌套点击外层选项
   */
  private clickParent(item) {
    if (!item.value) {
      item.content = "";
      if (item["options"] && item["options"].length > 0) {
        item["options"].forEach((ele) => {
          ele.value = false;
          ele.content = "";
        });
      }
    }
  }
  /**
   * @description 多多嵌套点击里层选项
   */
  private clickChild(child, parent) {
    if (child.value) {
      parent.value = true;
      if (this.content.type === "单多嵌套选择") {
        this.clickRatioParent(parent);
      }
    } else {
      child.content = "";
    }
  }
  /**
   * @description 单多、多多嵌套input值改变
   */
  private inputChange(child, parent) {
    if (child.content) {
      child.value = true;
      if (parent) {
        parent.value = true;
      }
      if (this.content.type === "单多嵌套选择") {
        this.clickRatioParent(child);
      }
    }
  }
  /**
   * @description 单多嵌套点击外层选项
   */
  private clickRatioParent(item) {
    this.content["options"].forEach((element) => {
      if (element.name !== item.name) {
        element.value = false;
        element.content = "";
        if (element["options"] && element["options"].length > 0) {
          element["options"].forEach((ele) => {
            ele.value = false;
            ele.content = "";
          });
        }
      }
    });
  }
  /**
   * @description 单选补充文字值改变
   */
  private clickDanbu(value) {
    this.content.options.forEach((option) => {
      if (value.includes(option.name)) {
        option.value = true;
      } else {
        option.value = false;
        if (option.content) {
          option.content = "";
        }
      }
    });
  }
}
